import {IAugmentedJQuery, IDirective, IScope, ITimeoutService} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";

/* https://gist.github.com/mlynch/dd407b93ed288d499778 */


/**
 * the HTML5 autofocus property can be finicky when it comes to dynamically loaded
 * templates and such with AngularJS. Use this simple directive to
 * tame this beast once and for all.
 *
 * Usage:
 * <input type="text" autofocus>
 *
 * MERK - for input element i $mdDialog, $mdBottomSheet, $mdMenu eller $mdSidenav MÅ md-autofocus benyttes.
 *
 * License: MIT
 */
export function autofocusForInjisering() {
    return [regNavn.ng.$timeout, autofocus]
}

export function autofocus($timeout: ITimeoutService): IDirective {
    return {
        restrict: 'A',
        link: ($scope: IScope, $element: IAugmentedJQuery) => {
            $timeout(() => $element.focus(), 0, false); //ingen grunn til å kjøre digest ifbm dette
        }
    }
}
